<template>
    <div class="editable-text">
        <div class="text" :id="id">{{ value || '&nbsp;' }}</div>
        <div ref="template" class="template">
            <textarea ref="textarea" class="form-control" rows="5" v-model="valueMutable" @keydown.meta.enter="storeValue" @keydown.esc="reset"></textarea>
            <div class="row m-t-xs">
                <div class="col-sm-6">
                    <button class="btn btn-block btn-sm btn-default" @click="reset">
                        <i class="fa fa-close"></i>
                    </button>
                    <small class="text-white">(esc)</small>
                </div>
                <div class="col-sm-6">
                    <button class="btn btn-block btn-sm btn-success" @click="storeValue">
                        <i class="fa fa-check"></i>
                    </button>
                    <small class="text-white">(cmd + Enter)</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
    props: {
        id: {
            type: String,
            default() {
                return `tooltip-${this._uid}`;
            },
        },
        value: String,
    },
    data() {
        return {
            tooltip: null,
            valueMutable: this.value,
        }
    },
    mounted() {
        this.tooltip = tippy(`#${this.id}`, {
            allowHTML: true,
            content: this.$refs.template,
            trigger: 'click',
            interactive: true,
            placement: 'bottom',
            onShown: function(){
                this.$refs.textarea.focus();
            }.bind(this)
        });
    },
    methods: {
        storeValue() {
            this.$emit('input', this.valueMutable);
            this.closeTooltip();
        },
        closeTooltip() {
            this.tooltip[0].hide();
        },
        reset() {
            this.valueMutable = this.value;
            this.closeTooltip();
        }
    }
}
</script>

<style scoped>
.editable-text .text {
    border-bottom: 1px dashed #aaa;
    cursor: pointer;
}

.editable-text .template {
    color: #333;
}
</style>
